import React from "react";

import { withStyles, Styles } from "./styles";
import { HERO_MAIN_IMAGE_WIDTH } from "./constants";
import { HERO_MAIN_ILLUSTRATION_ID_CONTAINER } from "../../../../../constants";

interface ContentProps extends Styles {
  businessUnitName: string;
  businessUnitImage?: string;
}

const ContentBase: React.FC<ContentProps> = ({
  classes,
  businessUnitName,
  businessUnitImage,
  children
}) => (
  <div className={classes.contentWrapper}>
    <div className={classes.contentMain} data-id={HERO_MAIN_ILLUSTRATION_ID_CONTAINER}>
      <div>{children}</div>
      {businessUnitImage && (
        <img
          className={classes.contentImage}
          src={businessUnitImage}
          alt={`${businessUnitName} ComparaOnline`}
          width={HERO_MAIN_IMAGE_WIDTH}
        />
      )}
    </div>
  </div>
);

export const Content = withStyles(ContentBase);
